import PaxInfo from './PaxInfo';

export default PaxInfo;
